import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { resetVirtualTerminalProxy, virtualTerminalProxy } from '../../virtualTerminalProxy'
import { usdFormatter } from '../../../../../../shared/utils/formattingUtils'
import { executeAddCardSaleByToken } from '../../../../../../shared/apiUtils/executeAddCardSaleByToken'
import { formatFullName } from '../../../../../../shared/utils/stringUtils'
import { proxyGlobalAuth } from '../../../../../../shared/proxies/proxyGlobalAuth'

export function PaymentSummary (): ReactElement {
  const { allowSubmit, showAmountError, customer, form: { values } } = useSnapshot(virtualTerminalProxy)
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <div className="bg-white shadow rounded p-6">
      <div className="text-3xl text-center">
        {
          (values.amount && !showAmountError)
            ? usdFormatter.format(parseFloat(values.amount as string))
            : '$-----'
        }
      </div>
      {customer && (
        <div className="bg-wpy-light-gray-300 rounded-sm p-2 my-2" style={{ minHeight: '3rem' }}>
          <h3 className="font-semibold">Company Information:</h3>
          <p>{customer.companyName}</p>
          {(customer.firstName || customer.lastName) && <p>{formatFullName(customer.firstName, customer.lastName)}</p>}
          {customer.email && <p>{customer.email}</p>}
          {customer.addressOne && <p>{customer.addressOne}</p>}
          {customer.addressTwo && <p>{customer.addressTwo}</p>}
          <p>
            {customer.city}
            {customer.city && customer.state ? ', ' : ''}
            {customer.state}
            {customer.state && customer.postalCode ? ' ' : ''}
            {customer.postalCode}
          </p>
        </div>
      )}
      <div className="flex">
        <button
          className={cn(buttonColors.secondaryClasses, 'flex justify-center items-center rounded border px-6 py-2  mr-4 w-1/3')}
          onClick={resetVirtualTerminalProxy}
        >
          Reset
        </button>
        <button
          className={
            cn(
              buttonColors.classes,
              'flex justify-center items-center rounded px-6 py-2 text-white flex-grow font-semibold'
            )
          }
          onClick={executeAddCardSaleByToken}
          disabled={!allowSubmit}
        >
          {
            values.amount && !showAmountError
              ? `Charge ${usdFormatter.format(parseFloat(values.amount as string))}`
              : 'Charge'
          }
        </button>
      </div>
    </div>
  )
}
